import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
const AreasOfWorkView =  ({ profile }) => {

  const { t } = useTranslation();
  const workAreas = [
    { id: "infants", label: t("Care of infants/children"), extra: t("Age range") },
    { id: "elderly", label: t("Care of elderly") },
    { id: "disabled", label: t("Care of disabled") },
    { id: "housework", label: t("General housework")},
    { id: "cooking", label: t("Cooking"), extra: t("Cuisines") }
  ];

  return (
    <div className="mt-4">
      <h6 className="text-decoration-underline fw-bold">{t("Areas of Work")}</h6>
      {workAreas.map((work) => {
        
        const workData = profile?.areas_of_work?.[work.id];
       
        if (!workData) return null;

        return (
          <div key={work.id} className="border rounded p-3 mb-3 bg-light">
            <p><strong>{t("Type")}:</strong> {work.label}</p>
            {work.extra && workData.extra && (
              <p><strong>{work.extra}:</strong> {workData.extra}</p>
            )}
            <p><strong>{t("Willing to do this work")}:</strong> {workData.willing ? t("Yes") : t("No")}</p>
            <p><strong>{t("Has experience")}:</strong> {workData.experience ? t("Yes") : t("No")}</p>
            {workData.experience && (
              <p><strong>{t("Years of experience")}:</strong> {workData.experience_years}</p>
            )}
             <p><strong>{t("Rate")}:</strong> {workData.rating || "N.A"}</p>
          </div>
        );
      })}
    </div>
  );
}
AreasOfWorkView.propTypes = {
  profile: PropTypes.object.isRequired,

};
export default AreasOfWorkView;    